import classNames from 'classnames';
import injectSheet from 'react-jss';

import {position, rem, phoneScreen} from '-/styles/utils';

const styles = {
    root: {
        ...position({
            position: 'absolute',
            bottom: rem(-25),
            right: rem(-115)
        }),
        ...phoneScreen({
            ...position({
                position: 'absolute',
                bottom: rem(-20),
                right: rem(-83)
            })
        }),
        transition: 'all 0.3s ease-in-out',
        '&:active, &:hover, &.active': {
            right: '0'
        },
        '& img': {
            ...phoneScreen({
                height: rem(60)
            })
        }
    }
};

const PhoneCallout = props => {
    const {idle = false, number, classes = {}, svgUrl} = props;

    if (!number) {
        return null;
    }

    const className = classNames(classes.root, {
        active: idle
    });

    return (
        <div className={className}>
            <a href={`tel:${number}`}><img src={svgUrl} alt="Phone Number" /></a>
        </div>
    );
};

export default injectSheet(styles)(PhoneCallout);